"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FilledPinIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function FilledPinIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M12 1C7.04932 1 3.02197 4.87402 3.02197 9.63672C3.02197 14.1182 5.5 16.4463 7.68652 18.5C9.46435 20.1709 11 21.6133 11 24H13C13 21.6133 14.5356 20.1709 16.3135 18.5C18.5 16.4463 20.978 14.1182 20.978 9.63672C20.978 4.87402 16.9507 1 12 1ZM14 10C14 11.1045 13.1046 12 12 12C10.8955 12 10 11.1045 10 10C10 8.89539 10.8955 8 12 8C13.1046 8 14 8.89539 14 10Z",
    fill: "currentColor"
  }));
}